<template>
    
<div class="item">

    <div v-if="!window.is.mobile" class="item-avatar" :class="{'is-empty': !avatar}" :style="{backgroundImage: avatar}"></div>

    <div v-if="window.is.mobile" class="item-banner" :style="{backgroundImage: banner}">

        <div class="item-avatar" :class="{'is-empty': !avatar}" :style="{backgroundImage: avatar}"></div>

    </div>
    
    <div class="item-content">

        <div class="item-content-about">

            <div class="item-content-about-text">

                <div class="item-content-about-text-name">

                    <router-link :to="{name: 'Business', params: { slug: item.slug }, query: { search: searchQuery }}">{{ item.name }}</router-link>

                    <div class="item-content-about-text-name-pricing" v-if="item.prices">

                        <template v-if="item.prices >= 1">£</template>
                        <template v-if="item.prices >= 2">£</template>
                        <template v-if="item.prices >= 3">£</template>

                    </div>

                </div>

                <div class="item-content-about-text-description" v-if="item.description">{{ item.description }}</div>

                <div class="item-content-about-text-status" v-if="item.status">{{ item.status }}</div>

            </div>
            
            <div v-if="!window.is.mobile" class="item-content-about-band" :class="{[classRating]: true}"></div>

        </div>

        <div class="item-content-contact">

            <div class="item-content-contact-item">
                
                <app-icon name="location" /> 
                <div class="item-content-contact-item-text"><a :href="linkAddress">{{ address }}</a><small v-if="item.distance">{{item.distance}} miles</small></div>
                
            </div>

            <div class="item-content-contact-item">
                
                <app-icon name="phone" /> 
                <div class="item-content-contact-item-text"><a :href="linkPhone">{{ item.phone }}</a></div>

            </div>

        </div>
        
        <div class="item-content-actions" :class="{'is-single': isSessionBusiness}">

            <app-button :to="{name: 'Business/Reviews/Write', params: { slug: item.slug }, query: { cancel: $route.fullPath }}" theme="yellow" :text="page.results_review" v-if="!isSessionBusiness" />
            <app-button :to="{name: 'Business', params: { slug: item.slug }, query: { search: searchQuery }}" :theme="(window.is.mobile) ? 'blue' : 'grey'" :text="page.results_more" :arrow="!window.is.mobile" />

        </div>

    </div>

</div>

</template>

<script>

export default {

    props: ['item'],

    computed: {

		searchQuery: function() {

			return JSON.stringify(this.$route.query)

		},

        address: function() {

            var address = []

            if (this.item.address.first) address.push(this.item.address.first)
            if (this.item.address.second) address.push(this.item.address.second)
            if (this.item.address.city) address.push(this.item.address.city)
            if (this.item.address.county) address.push(this.data.counties[this.item.address.county])
            if (this.item.address.postcode) address.push(this.item.address.postcode)

            return address.join(', ')

        },

        classRating: function() {

            return 'band-' + this.item.rating.toString()

        },

        linkAddress: function() {

            return 'https://www.google.co.uk/maps/search/' + encodeURIComponent(this.address)
             
        },

        linkPhone: function() {

            return 'tel:' + this.item.phone.replace(' ', '')

        },

        avatar: function() {

            return (this.item.avatar) ? 'url(' + this.item.avatar + ')' : false

        },

        banner: function() {

            return (this.item.banner) ? 'url(' + this.item.banner + ')' : false

        }

    }

}

</script>

<style scoped>

.item {
    border: 1px solid var(--color-grey-light);
    padding: 20px;
    border-radius: 4px;
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;
    align-items: flex-start;
}

.is-mobile .item {
    padding: 0px;
    border-radius: 0px;
    flex-direction: column;
    border-width: 0px;
    margin-bottom: 10px;
}

.item:last-child {
    margin-bottom: 0px;
}

.is-desktop .item:hover {
    border-color: var(--color-grey-highlight);
}

.item-banner {
    width: 100%;
    height: 100px;
    background-position: 50% 50%;
    background-size: cover;
    background-color: var(--color-blue-light);
    margin-bottom: 20px;
}

.item-avatar {
    flex-shrink: 0;
    width: 140px;
    height: 140px;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    margin-right: 20px;
    border-radius: 4px;
}

.is-mobile .item-avatar {
    width: 100px;
    height: 100px;
    position: absolute;
    left: 50%;
    top: 20px;
    margin-left: -50px;
    border: 4px solid #fff;
}

.item-avatar.is-empty {
    background-image: url(~@/assets/avatar.png);
    background-color: var(--color-blue-light);
    background-size: 80px auto;
    background-repeat: no-repeat;
}

.item-content {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
}

.is-mobile .item-content {
    padding: 10px;
	flex-basis: auto;
	width: 100%;
}

.item-content-about {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 20px;
}

.item-content-about-text {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.is-mobile .item-content-about-text {
	align-items: center;
}

.item-content-about-text-name {
    font-family: "grueber", serif;
    font-size: 24px;
    line-height: 24px;
    color: var(--color-grey-dark);
    display: flex;
    flex-direction: row;
    align-items: center;
}

.is-mobile .item-content-about-text-name {
    margin-bottom: 10px;
}   

.item-content-about-text-name-pricing {
    background-color: var(--color-blue-light);
    color: #fff;
    font-size: 10px;
    margin-left: 10px;
    line-height: 10px;
    padding: 2px 4px;
    border-radius: 4px;
}

.item-content-about-text-status {
	background-color: var(--color-grey-light);
	color: var(--color-grey-dark);
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
	padding: 10px;
	border-radius: 4px;
	margin-top: 12px;
	width: 100%;
}

.item-content-about-text-status:before {
    content: ' ';
    position: absolute;
    left: 20px;
    top: -8px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 8px 8px 8px;
    border-color: transparent transparent var(--color-grey-light) transparent;
}

.is-mobile .item-content-about-text-status {
	text-align: center;
}

.is-mobile .item-content-about-text-status:before {
	left: 50%;
	margin-left: -4px;
}

.item-content-about-text-description {
    font-size: 14px;
    line-height: 18px;
    font-weight: 300;
    color: var(--color-grey-dark);
}

.is-mobile .item-content-about-text-description {
	text-align: center;
}

.item-content-about-band {
    width: 48px;
    height: 48px;
    margin-left: 20px;
    border-radius: 4px;
    flex-shrink: 0;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: 32px 32px;
    background-image: url(data:image/png;base64,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);
}

.item-content-about-band.band-0 {
    background-color: var(--color-band-0);
}

.item-content-about-band.band-1 {
    background-color: var(--color-band-1);
}

.item-content-about-band.band-2 {
    background-color: var(--color-band-2);
}

.item-content-about-band.band-3 {
    background-color: var(--color-band-3);
}

.item-content-contact {
    background-color: var(--color-grey-lightest);
    border-radius: 4px;
    padding: 20px 20px 15px 20px;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
}

.item-content-contact-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
}

.item-content-contact-item:last-child {
    margin-bottom: 0px;
}

.item-content-contact-item >>> .icon {
    width: 24px;
    line-height: 32px;
    text-align: center;
    height: 32px;
    flex-shrink: 0;
    font-size: 20px;
    color: var(--color-blue-light);
}

.item-content-contact-item-text {
    padding-left: 15px;
    flex-grow: 1;
    color: var(--color-grey-dark);
}

.item-content-contact-item-text a {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: bold;
}

.is-desktop .item-content-contact-item-text a:hover {
    text-decoration: underline;
}

.item-content-contact-item-text small {
    font-size: 11px;
    margin-top: 2px;
    display: block;
}

.item-content-actions {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.is-mobile .item-content-actions {
    flex-direction: column;
}

.is-mobile .item-content-actions >>> .button {
    width: 100%;
    margin-bottom: 4px;
}

.is-mobile .item-content-actions >>> .button-text {
    width: 100%;
	text-align: center;
}

.item-content-actions.is-single {
    justify-content: flex-end;
}

</style>